module.exports = __webpack_public_path__ + "img/bx-manage-choosing.a3c5cf6a.svg";